import { render } from "./CollaboratingPublications.vue.js?vue&type=template&id=0c41f88d!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratingPublications.vue?vue&type=template&id=0c41f88d"
import script from "./CollaboratingPublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratingPublications.vue?vue&type=script&lang=js"
export * from "./CollaboratingPublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratingPublications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/CollaboratingPublications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c41f88d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c41f88d', __exports__)) {
    api.reload('0c41f88d', __exports__)
  }
  
  module.hot.accept("./CollaboratingPublications.vue.js?vue&type=template&id=0c41f88d!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratingPublications.vue?vue&type=template&id=0c41f88d", () => {
    api.rerender('0c41f88d', render)
  })

}


export default __exports__